import { createContext, useContext } from 'react';

export const ModalPortalContext = createContext<HTMLElement | null>(null);

export const useModalPortalTarget = (): HTMLElement | null =>
  useContext(ModalPortalContext);
